@use "../../sass/global/global" as *;

ux-iws-nb-contact-modal {
    display: inline-block;
    box-sizing: border-box;

    * {
        box-sizing: border-box;
    }
}
